import ExecutiveDashboardTemplate from "Components/templates/executive/dashboard";

const ExecutiveDashboard = () => {
    document.title = "Executive Dashboard | IbexIQ";
    return <ExecutiveDashboardTemplate />
}

export default ExecutiveDashboard;